export class Range {
    text: string;
    val: string;
    class: string;
    constructor(text, val,clas) {
    this.text = text;
    this.val = val;
    this.class = clas;
} 
}


// WEBPACK FOOTER //
// ./src/app/components/class/datepicker/range.ts